import { render, staticRenderFns } from "./FileComponent.vue?vue&type=template&id=7c41e3b9&scoped=true&"
import script from "./FileComponent.vue?vue&type=script&lang=js&"
export * from "./FileComponent.vue?vue&type=script&lang=js&"
import style0 from "./FileComponent.vue?vue&type=style&index=0&id=7c41e3b9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c41e3b9",
  null
  
)

export default component.exports